export default __webpack_public_path__ + "static/media/supportPerson.790074f7.png";